var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.state
    ? _c(
        "div",
        {
          class: [
            "margin-top-lg laptop:margin-top-0",
            { "display-none": !_vm.hasRefinements && !_vm.hasSearchTerm },
          ],
        },
        [
          _c(
            "ul",
            {
              staticClass: "display-inline-flex flex-row flex-wrap",
              staticStyle: {
                "--list-style-type": "none",
                "--padding-left": "0",
                "--margin-top": "0",
                "--margin-bottom": "calc(var(--spacing-2xs) * -1)",
                "--margin-right": "calc(var(--spacing-sm) * -1)",
              },
            },
            [
              _c("search-refinement-widget", {
                on: { clearSearchQuery: _vm.clearSearchQuery },
              }),
              _vm._v(" "),
              _vm._l(_vm.currentRefinements, function (item) {
                return _c("li", { key: item.attribute }, [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(item.label) + ":"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "display-inline-flex flex-row flex-wrap",
                      staticStyle: {
                        "--list-style-type": "none",
                        "--padding-left": "0",
                        "--margin-top": "0",
                        "--margin-bottom": "0",
                      },
                    },
                    _vm._l(item.refinements, function (refinement) {
                      return _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                refinement.attribute !== "icon_collections",
                              expression:
                                "refinement.attribute !== 'icon_collections'",
                            },
                          ],
                          key: [
                            refinement.attribute,
                            refinement.type,
                            refinement.value,
                            refinement.operator,
                          ].join(":"),
                          staticClass: "margin-bottom-2xs margin-right-sm",
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "icon-facet-pill tag secondary rounded",
                              staticStyle: {
                                "--link-decoration-style": "none",
                                "--link-decoration-line": "none",
                                "--link-hover-decoration-style": "none",
                                "--link-hover-decoration-line": "none",
                                "--tag-padding":
                                  "var(--spacing-sm) var(--spacing-md)",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.removeRefinement(item, refinement)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.displayRefinement(refinement)) +
                                  "\n            "
                              ),
                              _c("font-awesome-icon", {
                                staticClass:
                                  "icon-facet-pill-affordance margin-left-4xs",
                                attrs: {
                                  icon: _vm.$v6.solid.faXmark,
                                  "fixed-width": "",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              }),
              _vm._v(" "),
              _c("clear-widget", {
                attrs: { "has-refinements": _vm.hasRefinements },
                on: { clearSearchQuery: _vm.clearSearchQuery },
              }),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }